import "./acessoEmBreve.css";
import "../../styles/bg-responsive.css";
import "../../styles/auth-logo.css";
import sbfLogo from "../../assets/SBF-Logo-1.png";
import { useNavigate } from "react-router-dom";

const AcessoEmBreve = () => {
  const navigate = useNavigate();

  return (
    <div className="container-acesso-em-breve">
      <div className="logo-wrapper">
        <img src={sbfLogo} alt="SBF" className="logo-acesso-em-breve" />
      </div>
      <div className="conteudo-acesso-em-breve">
        <h1>Em breve</h1>
        <p>
          Liberaremos os acessos à plataforma em breve. Suas credenciais foram
          validadas, mas o acesso ainda não está disponível para o seu perfil.
        </p>
        <p>
          Em caso de dúvidas, entre em contato pelo e-mail{" "}
          <b>sbf@informa.com</b>
        </p>
        <button
          type="button"
          className="btn-voltar-login"
          onClick={() => navigate("/login")}
        >
          Voltar ao login
        </button>
      </div>
    </div>
  );
};

export default AcessoEmBreve;
